export const viewMemoTitle = {
  'wt': 'Withholding Tax Memo',
  'ct': 'Corporate Tax Memo'
};

export const viewMemoToolId = {
  'wt': 'itrce-rate-memo-withholding-tax-rate',
  'ct': 'itrce-rate-memo-corporate-tax-rate'
};


export const withholdingTax = "wt";
export const corporateTax = "ct";
